import { defineMessages, IntlShape } from "react-intl";

import SortOrder from "@mapmycustomers/shared/enum/SortOrder";

const messagesDesc = defineMessages<string>({
  completedAt: {
    id: "activities.quickSortFilterOption.completedAt.descDirection",
    defaultMessage: "Most recently done",
    description: "activities quicksort filter option - Done at desc direction",
  },
  createdAt: {
    id: "activities.quickSortFilterOption.createdAt.descDirection",
    defaultMessage: "Most recently created",
    description: "activities quicksort filter option - Created at desc direction",
  },
  dueDate: {
    id: "activities.quickSortFilterOption.dueAt.descDirection",
    defaultMessage: "Most recently overdue",
    description: "activities quicksort filter option - Due Date desc direction",
  },
  dueDateOverride: {
    id: "activities.quickSortFilterOption.startAtNewest.descDirection",
    defaultMessage: "Newest",
    description: "activities quicksort filter option - Start at desc direction",
  },
  startAt: {
    id: "activities.quickSortFilterOption.startAt.descDirection",
    defaultMessage: "Soonest",
    description: "activities quicksort filter option - Start at desc direction",
  },
  updatedAt: {
    id: "activities.quickSortFilterOption.modifiedAt.descDirection",
    defaultMessage: "Most recently modified",
    description: "activities quicksort filter option - Modified at desc direction",
  },
});

const messagesAsc = defineMessages<string>({
  completedAt: {
    id: "activities.quickSortFilterOption.completedAt.ascDirection",
    defaultMessage: "Least recently done",
    description: "activities quicksort filter option - Done at asc direction",
  },
  createdAt: {
    id: "activities.quickSortFilterOption.createdAt.ascDirection",
    defaultMessage: "Least recently created",
    description: "activities quicksort filter option - Created at asc direction",
  },
  dueDate: {
    id: "activities.quickSortFilterOption.dueAt.ascDirection",
    defaultMessage: "Longest overdue",
    description: "activities quicksort filter option - Due date asc direction",
  },
  dueDateOverride: {
    id: "activities.quickSortFilterOption.startAtOldest.ascDirection",
    defaultMessage: "Oldest",
    description: "activities quicksort filter option - Start at asc direction",
  },
  startAt: {
    id: "activities.quickSortFilterOption.startAt.ascDirection",
    defaultMessage: "Farthest out",
    description: "activities quicksort filter option - Start at asc direction",
  },
  updatedAt: {
    id: "activities.quickSortFilterOption.modifiedAt.ascDirection",
    defaultMessage: "Least recently modified",
    description: "activities quicksort filter option - Modified at asc direction",
  },
});

const getSortDirectionNameForField = (
  intl: IntlShape,
  fieldName: string,
  order: SortOrder
): string =>
  order === SortOrder.DESC
    ? intl.formatMessage(messagesDesc[fieldName])
    : intl.formatMessage(messagesAsc[fieldName]);

export default getSortDirectionNameForField;
